import Service from "../../AuthService";

const Payment = {
    getPayments(params) {
        return Service.get("/payment", {
            params: params
        })
    },
    getPaymentById(id) {
        return Service.get("/payment/" + id)
    },
    createPayment(data) {
        return Service.post("/payment", data)
    },
    updatePayment(id, data) {
        return Service.put("/payment/" + id, data)
    },
    deletePayment(id) {
        return Service.delete("/payment/" + id)
    }
}

export default Payment
